module.exports = __webpack_public_path__ + "img/mesa_d114.42cbae42.png";